import * as React from 'react';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import BookDetails from './BookDetails';
import {ProductSearchProps} from '../../../../types/types';

const Result = () => {
  const {
    show = false,
    loading = false,
    data = [],
  } = useSelector((state: RootState) => state.books);

  if (loading) {
    return (
      <Grid>
        <LinearProgress />
      </Grid>
    );
  }
  if (show && data !== undefined) {
    return (
      <Grid container display="contents">
        {data.map((book: ProductSearchProps) => (
          <BookDetails book={book} />
        ))}
      </Grid>
    );
  }
  return <p />;
};

export default Result;
